import { _Object } from '../context'
const nativeGetSymbols = _Object.getOwnPropertySymbols
export default nativeGetSymbols
